import faker from 'faker'
import moment from 'moment'
import hres62eLabels from 'assets/labels/hres62e'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hres62eLabels
    }
  },
  index () {
    let mockRows = []
    const mockTotal = 100
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        id: i,
        dtereq: moment().format('DD/MM/YYYY'),
        seqno: faker.random.number().toString().substr(0, 1),
        numlereq: faker.random.number(),
        desc_codleave: faker.lorem.word(),
        dtestrt: moment().format('DD/MM/YYYY'),
        dteend: moment().format('DD/MM/YYYY'),
        timstrt: faker.date.past().toString().substr(16, 5),
        timend: faker.date.past().toString().substr(16, 5),
        status: faker.lorem.word(),
        remarkap: faker.lorem.sentence(),
        desc_codappr: faker.lorem.word(),
        desc_codempap: faker.lorem.word()
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  create () {
    let mockCreate = {
      codempid: faker.lorem.word(),
      seqno: faker.random.number().toString().substr(0, 1),
      dtereq: moment().format('DD/MM/YYYY'),
      staappr: faker.lorem.word(),
      routeno: '',
      codleave: '',
      desc_codleave: '',
      p_entitlement_day: '',
      p_entitlement_hour: '',
      p_entitlement_min: '',
      flgleave: '',
      dteleave: moment().format('DD/MM/YYYY'),
      dtestrt: moment().format('DD/MM/YYYY'),
      dteend: moment().format('DD/MM/YYYY'),
      timstrt: '',
      timend: '',
      deslereq: ''
    }

    return mockCreate
  },
  detail () {
    let mockDetail = {
      codempid: faker.lorem.word(),
      numseq: faker.random.number().toString().substr(0, 1),
      dtereq: moment().format('DD/MM/YYYY'),
      staappr: faker.lorem.word(),
      routeno: faker.lorem.word(),
      codleave: faker.lorem.word(),
      desc_codleave: faker.lorem.word(),
      p_entitlement_day: '',
      p_entitlement_hour: '',
      p_entitlement_min: '',
      flgleave: faker.lorem.word(),
      dteleave: moment().format('DD/MM/YYYY'),
      dtestrt: moment().format('DD/MM/YYYY'),
      dteend: moment().format('DD/MM/YYYY'),
      timstrt: faker.date.past().toString().substr(16, 5),
      timend: faker.date.past().toString().substr(16, 5),
      deslereq: faker.lorem.word()
    }

    return mockDetail
  },
  dropdowns () {
    let mockCodleaveEn = {}
    let mockCodleaveTh = {}
    const mockTotal = Math.floor(Math.random() * 15) + 10
    for (var i = 1; i <= mockTotal; i++) {
      mockCodleaveEn[faker.lorem.word()] = faker.lorem.word()
      mockCodleaveTh[faker.lorem.word()] = faker.lorem.word()
    }
    return {
      codleave: {
        en: mockCodleaveEn,
        th: mockCodleaveTh
      }
    }
  },
  save () {
    return labels.mockPostMessage
  },
  cancel () {
    return labels.mockPostMessage
  },
  entitleFlagLeave () {
    return {
      entitlement: {
        day3: Math.floor(Math.random() * 20),
        hur3: Math.floor(Math.random() * 20),
        min3: Math.floor(Math.random() * 20)
      },
      enableflagleave: {
        r1: (Math.floor(Math.random() * 2) <= 0.5) ? 'T' : 'F',
        r2: (Math.floor(Math.random() * 2) <= 0.5) ? 'T' : 'F',
        r3: (Math.floor(Math.random() * 2) <= 0.5) ? 'T' : 'F',
        r4: (Math.floor(Math.random() * 2) <= 0.5) ? 'T' : 'F'
      }
    }
  },
  worktime () {
    return {
      m_timstrt: faker.date.past().toString().substr(16, 5),
      m_timend: faker.date.past().toString().substr(16, 5),
      e_timstrt: faker.date.past().toString().substr(16, 5),
      e_timend: faker.date.past().toString().substr(16, 5),
      timstrt_tleaverq: faker.date.past().toString().substr(16, 5),
      timend_tleaverq: faker.date.past().toString().substr(16, 5)
    }
  },
  popup () {
    return {
      codleave: faker.random.word(),
      desc_codleave: faker.random.words(),
      flgchol: faker.random.word(),
      desc_flgchol: faker.random.words(),
      condition: faker.random.words()
    }
  },
  getCodleave () {
    let mockRows = []
    const mockTotal = 10
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        codleave: faker.random.word(),
        desc_codleave: faker.random.words()
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/hres62e/mocker.js